import React, { useState } from 'react'
import './styles.scss'
import Login from '../Login';
import Signup from '../Signup';
import ForgotPassword from '../ForgotPassword';

const TitleScreen = ({closeTitleScreen}) => {

const [showLogin,setShowLogin] = useState("login")

function switchLogin(value){
    setShowLogin(value)
}

    return (
        <div className="title-screen" style={{backgroundImage: `url(https://mhreserve.com/wp-content/uploads/reserve/assets/title-image-2.jpg)`}}>
                <img src='assets/logo.png' className='logo-title-screen'/>
            <div className='title-screen-content'>
            {showLogin=="login" && <Login switchLogin={switchLogin} closeTitleScreen={closeTitleScreen}/>}
            {showLogin=="create" && <Signup switchLogin={switchLogin} closeTitleScreen={closeTitleScreen}/>}
            {showLogin=="forgot" && <ForgotPassword switchLogin={switchLogin} closeTitleScreen={closeTitleScreen}/>}
            </div>
        </div>
    )
}

export default TitleScreen